import { saveAs } from "file-saver";
import UKToast from "@/components/UKToast/index";
import { useTranslation } from "react-i18next";

/**
 * 保存文件到本地
 * @param fileUrl 文件的URL
 * @param fileType 文件类型 image | pdf
 */
export const useFileSaver = () => {
  const { t } = useTranslation();
  const saveFile = (fileUrl: string, fileType: string) => {
    // 从 URL 提取文件名
    let fileName = fileUrl.substring(fileUrl.lastIndexOf("/") + 1);
    // 删除url问号后面的参数
    fileName = fileName.split("?")[0];

    // 如果文件名为空，使用默认文件名
    if (!fileName) {
      fileName = `downloaded-${fileType || "file"}`; // 默认文件名 file
    }

    // 创建一个新的请求
    fetch(fileUrl)
      .then((response) => {
        if (!response.ok) {
          UKToast.show({
            content: t("order.orderDetail.invoiceModal.downloadFailTips"), // 弹窗内容
            icon: "warning", // 可选：success, fail, loading, warn, info，影响图标
          });
          throw new Error("网络错误");
        }
        return response.blob(); // 将响应转换为 Blob
      })
      .then((blob) => {
        saveAs(blob, fileName); // 使用 saveAs 保存文件
        UKToast.show({
          content: t("order.orderDetail.invoiceModal.downloadSuccessTips"), // 弹窗内容
          icon: "success", // 可选：success, fail, loading, warn, info，影响图标
          duration: 2000, // 不写的话默认3000
        });
      })
      .catch((error) => {
        UKToast.show({
          content: t("order.orderDetail.invoiceModal.downloadFailTips"), // 弹窗内容
          icon: "warning", // 可选：success, fail, loading, warn, info，影响图标
        });
        console.error("下载失败:", error);
      });
  };
  return { saveFile };
};
